import styled from "styled-components";

export const InputsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    .filter__text-input:first-child input {
        width: 100%;
        border-radius: 6px 0 0 6px;
    }

    .filter__text-input:last-child input {
        border-radius: 0 6px 6px 0;
        border-left-width: 0;

        :focus {
            margin-left: -1px;
            border-left-width: 1px;
        }
    }

    input {
        border-radius: 4px;
    }
`;
